import { render, staticRenderFns } from "./EmailBroadcastValidatedDomainsModal.vue?vue&type=template&id=54a2382a&scoped=true"
import script from "./EmailBroadcastValidatedDomainsModal.vue?vue&type=script&lang=js"
export * from "./EmailBroadcastValidatedDomainsModal.vue?vue&type=script&lang=js"
import style0 from "./EmailBroadcastValidatedDomainsModal.vue?vue&type=style&index=0&id=54a2382a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a2382a",
  null
  
)

export default component.exports